import routerOptions0 from "/var/www/rare-database/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.1_@types+node@25.0.1_@vue+compiler-sfc@3.5.25_cac@6.7.1_3ab5a58280573d597f608d1d6f347996/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/var/www/rare-database/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}